export default __webpack_public_path__ + "static/media/INT.0a5a57cf.jpg";